export default "__VITE_ASSET__BlbPvOr4__"